import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=6a853684&scoped=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=ts"
export * from "./PasswordResetForm.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=6a853684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a853684",
  null
  
)

export default component.exports